module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-75.f9033d32.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-75.png
// module id = 3296
// module chunks = 11